import React from "react";
import Home from "./pages/Home";
import Video from "./pages/Video";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import AWSVideo from "./pages/AWSVideo";
import OnlyVideo from "./pages/OnlyVideo";
import OnlyAWSVideo from "./pages/OnlyAWSVideo";
import WebECommerce from "./components/webECommerce/WebECommerce";
import WebECommerceReact from "./components/webECommerce2/WebECommerceReact";
import OnlyWebECommerceReact from "./components/VivamaisonHomepage/WebECommerceReact";
import uuid from 'react-uuid';
import JimmyKeyWebPage from "./components/JimmyKeyHomePage/Homepage/JimmyKeyWebPage";
import AsirWebPage from "./components/AsirTryin/Homepage/AsirWebPage";

function App() {

  if (localStorage.getItem("userId") === null) {
    localStorage.setItem('userId', uuid());
  }

  console.log(navigator.userAgent, " aaaa")
  console.log(localStorage.getItem("userId"))
  return (
    <Router>
      <Switch>
        <Route path="/asir/:dir/:id">
          <AsirWebPage showMetadata={true} />
        </Route>
        <Route path="/mobile/:dir/:id">
          <WebECommerceReact showMetadata={true} />
        </Route>
        <Route path="/jimmykey/:dir/:id">
          <JimmyKeyWebPage disableMetadata={false} showMetadata={false} />
        </Route>
        <Route path="/carousel/:dir/:id">
          <WebECommerce />
        </Route>
        <Route path="/onlycarousel/:dir/:id">
          <OnlyWebECommerceReact disableMetadata={true} showMetadata={true} />
        </Route>
        <Route path="/wix/:dir/:id">
          <OnlyWebECommerceReact disableMetadata={false} showMetadata={true}/>
        </Route>
        <Route path="/ticimax/:dir/:id">
          <OnlyWebECommerceReact disableMetadata={false} showMetadata={false} />
        </Route>
        <Route path="/sample2/:dir/:id">
          <WebECommerce />
        </Route>
        <Route path="/sample/:dir/:id">
          <Video />
        </Route>
        <Route path="/only/:dir/:id">
          <OnlyVideo />
        </Route>
        <Route path="/demo/only/:id">
          <OnlyAWSVideo />
        </Route>
        <Route path="/demo/:id">
          <AWSVideo />
        </Route>
        <Route path="/video/:id">
          <Video />
        </Route>
        <Route exact path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
